import React from 'react'
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from './ui/select'
import { Badge } from './ui/badge'
import { useOps } from '../hooks/useOps'

interface OpsSelectorProps {
  variant?: 'outline' | 'default'
  size?: 'sm' | 'default' | 'lg'
}

export function OpsSelector({ variant = 'outline', size = 'default' }: OpsSelectorProps) {
  const { currentOps, availableOps, switchOps, getOpsConfig, hasMultipleOps } = useOps()

  const handleValueChange = (value: string) => {
    switchOps(value)
  }

  if (!hasMultipleOps) {
    // Show current ops as badge if user only has access to one
    if (currentOps) {
      const config = getOpsConfig(currentOps)
      if (!config) return null
      
      return (
        <Badge
          className="text-white font-medium"
          style={{ backgroundColor: config.color }}
        >
          {config.displayName}
        </Badge>
      )
    }
    return null
  }

  return (
    <div className="space-y-2">
      <label className="text-sm font-medium text-muted-foreground">
        Operação Atual
      </label>
      <Select value={currentOps || ''} onValueChange={handleValueChange}>
        <SelectTrigger className="w-full">
          <SelectValue placeholder="Selecione uma operação" />
        </SelectTrigger>
        <SelectContent>
          {availableOps.map((ops) => {
            const config = getOpsConfig(ops)
            if (!config) return null
            
            return (
              <SelectItem key={ops} value={ops}>
                <div className="flex items-center gap-2">
                  <div
                    className="w-3 h-3 rounded-full"
                    style={{ backgroundColor: config.color }}
                  />
                  <span>{config.displayName}</span>
                </div>
              </SelectItem>
            )
          })}
        </SelectContent>
      </Select>
    </div>
  )
}